export default "__VITE_ASSET__4e702e98__"